export default function getFormatFromMime(mime) {
  if (typeof mime !== 'string') {
    return null;
  }
  if (mime.includes('wordprocessingml')) {
    return 'docx';
  }
  if (mime.includes('msword')) {
    return 'doc';
  }
  if (mime.includes('pdf')) {
    return 'pdf';
  }
  if (mime.includes('ms-excel') || mime.includes('spreadsheetml')) {
    return 'xls';
  }
  return null;
}
